__turbopack_context__.v({
  "app-footer": "sCQLAW_app-footer",
  "app-footer__link": "sCQLAW_app-footer__link",
  "app-footer__logo": "sCQLAW_app-footer__logo",
  "app-footer__main": "sCQLAW_app-footer__main",
  "app-footer__secondary": "sCQLAW_app-footer__secondary",
  "app-footer__section-group": "sCQLAW_app-footer__section-group",
  "app-footer__section-header": "sCQLAW_app-footer__section-header",
  "app-footer__separator": "sCQLAW_app-footer__separator",
});
